import { exportToPdfSpecs, exportToExcelSpecs } from "./export-specs";
export const getters = {
    exportToExcelSpecs() {
        return exportToExcelSpecs;
    },
    exportToPdfSpecs() {
        return exportToPdfSpecs;
    },
};
